import { Injectable, ViewContainerRef, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

const DURATION = 4000;

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private snackBar = inject(MatSnackBar);

  message(msg: string, viewContainer?: ViewContainerRef): MatSnackBarRef<SimpleSnackBar> {
    let config: MatSnackBarConfig = {
      duration: DURATION,
      panelClass: ['fullWidthSnack']
    };
    if (viewContainer) {
      config.viewContainerRef = viewContainer;
    }
    console.log(msg);

    return this.snackBar.open(msg + ' ', 'Note', config);
  }

  log(msg: string) {
    console.log(msg);
  }

  warn(msg: string): MatSnackBarRef<SimpleSnackBar> {
    console.warn(msg);

    return this.snackBar.open(msg, 'Warning', { duration: DURATION, panelClass: ['fullWidthSnack'] });
  }

  error(msg: string, error?: Error): MatSnackBarRef<SimpleSnackBar> {
    if (msg) {
      return this.snackBar.open(msg, 'Error', { duration: DURATION * 2, panelClass: ['fullWidthSnack'] });
    }
    if (msg || (error && error.message)) {
      console.error((msg || '') + (error && error.message ? error.message : ''));
    }
  }

  exception(error: Error): MatSnackBarRef<SimpleSnackBar> {
    if (error && error.message) {
      let config: MatSnackBarConfig = {
        duration: DURATION * 2,
        panelClass: ['fullWidthSnack']
      };
      console.error(error.message);

      return this.snackBar.open(error.message, 'Exception', config);
    }
  }
}